import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {AppComponent} from '../../app.component';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { element } from 'protractor';

export interface FilterData {
  filter: string;
  AdvanceSearch: any;
}

@Component({
    selector: 'app-view-library',
    templateUrl: './view-library.component.html',
    styleUrls: ['./view-library.component.css'],
    standalone: false
})
export class ViewLibraryComponent implements OnInit {

  url: string;
  DownloadURL: string;
  libraryDetail: any;
  modalURL: any;
  ModelFor: string;
  CallFunctionOnCloseModal: any;
  MsgType: number;
  DisplayMessage: string;
  FormSearchLibrary: FormGroup;
  pageNumber: number;
  advanceSearchValue: any;
  RightsID: string;
  pageSize = 10;
  pageIndex = 0;
  totalRecords = 0;
  filteredData: any[];
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder) {
    this.url = AppComponent.baseURL; this.DownloadURL = AppComponent.DownloadURL;
  }
  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202028001') || this.RightsID.includes('202028021') || this.RightsID.includes('202028000')) {
      } else {
        window.location.href = "module/0";
      }
    this.pageNumber = 1;
    this.MsgType = 1; //  Loading
    this.advanceSearchValue = "";
    this.fetchLibrary('');
    this.FormSearchLibrary = this.formBuilder.group({
      txtSearch: [''], advanceSearchValue: ['']
    });
    this.FormSearchLibrary.get('txtSearch').valueChanges.pipe(debounceTime(300),distinctUntilChanged()).subscribe(value => {
      this.filterTable(value);
    });
  }
  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.pageNumber = 1; 
    this.filterTable('');
  }
  receiveMessage(event) {
    if (event.data.data.Param != null)
    localStorage.setItem('advancesearch', event.data.data.Param);
    let element: HTMLElement;
    element = document.getElementsByClassName('close')[0] as HTMLElement;
    element.click();
  }

  OpenModal(url, cID, modelName, urld)    {
    this.modalURL =  url + "/" + cID;
    this.CallFunctionOnCloseModal = urld;
    this.ModelFor = modelName;
    if (modelName == "Filter") {
      // window.addEventListener("message", this.receiveMessage, false); // commented this line because it is throwing and can not understood the logic
      this.modalURL = "filter/202028000" ; }
  }
  onSearchLibrary(SearchData) {
    this.fetchLibrary(SearchData.txtSearch);
  }
  ReturnAdvanceSearch() {
    if (localStorage.getItem('advancesearch') != "") {
      this.advanceSearchValue = JSON.parse(localStorage.getItem('advancesearch')); }
    localStorage.setItem('advancesearch', "");
    this.fetchLibrary('');
    this.modalURL = ''; 
  }

  fetchLibrary(Param) {
    let filterData: FilterData = {
      filter: Param,
      AdvanceSearch: this.advanceSearchValue
     };
    this.http.post(this.url + 'Dashboard/SearchLibrary', filterData)
    .subscribe( (data) => {
        if (data == null || data.toString() == "[]") {
          this.MsgType = 2; // No Data Found
          this.DisplayMessage = "No Data Found";
          this.libraryDetail = null;
          this.filteredData = [];
        } else {
          this.MsgType = 0; // No Message
          this.libraryDetail = JSON.parse(data.toString());
          this.totalRecords = this.libraryDetail.length;
          this.filterTable('');
        }
      },
      (error) => {
         this.MsgType = 3; // Error Message
         this.DisplayMessage = error.message;
         this.libraryDetail = null;
       }
    );
  }
  filterTable(searchText: string) {
    if (!searchText) {
      this.filteredData = [...this.libraryDetail];
      return;
    }
    this.filteredData = this.libraryDetail.filter(row =>
      Object.values(row).some(val =>
        val?.toString().toLowerCase().includes(searchText.toLowerCase())
      )
    );
    this.pageNumber = 1;
  }
}
